module.exports = __webpack_public_path__ + "img/covid19_title_logo_fr@2x.d3b7cb64.png";